import { utils } from '../js/src/scripts.js';
import { combineReducers } from 'redux';

import { galaxoFloorMap } from '../js/src/scripts-galaxo.js';
import { galaxoSearch } from '../js/src/scripts-galaxo.js';
import { galaxoPageHeader } from '../js/src/scripts-galaxo.js';
import { galaxoList } from '../js/src/scripts-galaxo.js';
import { galaxoLocation } from '../js/src/scripts-galaxo.js';
import { businessIntro } from '../js/src/scripts-galaxo.js';
import { navGalaxo } from '../js/src/scripts-galaxo.js';
//import { $, jQuery } from '../js/lib/jquery.min.js';

//import { galaxoStats } from '../js/src/scripts-galaxo.js';
import { closingTimer } from '../js/src/scripts-galaxo.js';

//$(document).ready(function() {
//document.addEventListener("DOMContentLoaded", function(){

const galaxoStart = () => {

	// Make WP-core jQuery available globally
	window.$ = window.jQuery;

	var store = initReduxStore();

	// Initialize ALL THE STUFF
	galaxoFloorMap.init(store);
	galaxoSearch.init(store);
	galaxoList.init();
	businessIntro.init();
	navGalaxo.init();
	closingTimer.init();
	galaxoPageHeader.init();
	galaxoLocation.init(store);
	//galaxoStats.init();

	/*
	window.galaxoReset = function() {
		galaxoStats.send('reset');
		window.location.href = '/f_248/kauppakeskusvalkea.fi/galaxo/kartta/index.html';
	};
	*/

//});
};

// 'DOMContentLoaded' may fire before your script has a chance to run.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', galaxoStart);
} else {
	galaxoStart();
}


function initReduxStore() {

	var reducers = combineReducers({
		root: rootReducer,
		floorMap: galaxoFloorMap.reducer
	});
	var initialState = {
		root: {
			mql_LG: true
		},
		floorMap: {
			env: 'galaxo',
			locations: window.valkeaFloorMapData.infoscreenLocations
		}
	};

	return utils.createDevtoolsStore(reducers, initialState);
}

function rootReducer(oldState = {}, action) {
	return oldState;
}

//# sourceMappingURL=galaxo-new.js.map
